import "core-js/modules/es.array.map";
import React from "react";
import PropTypes from "prop-types";
import Rail from "web/react/components/rail/rail";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./homepage-store-rail.css";
var StorePropType = PropTypes.shape({
  title: PropTypes.string,
  image_url: PropTypes.string,
  image_alt: PropTypes.string,
  url: PropTypes.string
});
export function HomepageStoreItem(_ref) {
  var store = _ref.store;
  return React.createElement("div", {
    className: styles.homepageStoreItem
  }, React.createElement("a", {
    href: store.url
  }, React.createElement(LazyLoadImage, {
    className: styles.homepageStoreImg,
    src: store.image_url,
    alt: store.image_alt
  })), React.createElement("a", {
    className: styles.homepageStoreLink,
    href: store.url
  }, store.title));
}
HomepageStoreItem.propTypes = {
  store: StorePropType
};
export function HomepageStoreRail(_ref2) {
  var stores = _ref2.stores;
  return React.createElement("div", {
    className: styles.homepageStoreWrap
  }, React.createElement(Rail, {
    className: styles.homepageStoreRail,
    analyticsLabel: "homepage_store_rail",
    title: "",
    smallRail: true
  }, stores.map(function (store) {
    return React.createElement(HomepageStoreItem, {
      key: store.url,
      store: store
    });
  })));
}
HomepageStoreRail.propTypes = {
  stores: PropTypes.arrayOf(StorePropType).isRequired
};
export default HomepageStoreRail;